import axios from "axios";
import { BASE_URL, SCHEME_BASE_URL, BOOKING_BASE_URL } from "./adminUrlConfig";

const HEADERS = {
  "Api-Version": "v1",
  "Content-Type": "application/json",
  // Accept: "application/json",
};

const HEADERSMULTIPART = {
  "Api-Version": "v1",
  "Content-Type": "multipart/form-data",
  // Accept: "application/json",
};

export const UnAuthApiService = axios.create({
  baseURL: BASE_URL,
  headers: HEADERS,
});

export const ApiService = axios.create({
  baseURL: BASE_URL,
  headers: HEADERS,
});

export const SchemeApiService = axios.create({
  baseURL: SCHEME_BASE_URL,
  headers: HEADERS,
});

export const AssesmentApiService = axios.create({
  baseURL: process.env.REACT_APP_ASSESMENT_API_URL,
  headers: HEADERS,
});


export const FileUploadService = axios.create({
  baseURL: BASE_URL,
  headers: HEADERSMULTIPART,
});

export const SchemeFileUploadService = axios.create({
  baseURL: SCHEME_BASE_URL,
  headers: HEADERSMULTIPART,
});

ApiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token_admin");
    //console.log("token", token);
    if (token != null || token != undefined) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for API calls

ApiService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      window.location.href = "/admin-login";
      localStorage.removeItem("access_token_admin");
      return error.response;
    } else if (error.response.status === 404) {
      return error.response;
    } else {
      return error.response;
    }
  }
);


FileUploadService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token_admin");

    if (token != null || token != undefined) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  async (error) => {
    console.error("Error=>", error);
    return Promise.reject(error);
  }
);

SchemeApiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token_admin");
    //console.log("token", token);
    if (token != null || token != undefined) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for API calls

SchemeApiService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      window.location.href = "/admin-login";
      localStorage.removeItem("access_token_admin");
      return error.response;
    } else if (error.response.status === 404) {
      return error.response;
    } else {
      return error.response;
    }
  }
);

SchemeFileUploadService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token_admin");

    if (token != null || token != undefined) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  async (error) => {
    console.error("Error=>", error);
    return Promise.reject(error);
  }
);


AssesmentApiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token_admin");
    //console.log("token", token);
    if (token !== null && token !== undefined) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for API calls

AssesmentApiService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      window.location.href = "/admin-login";
      localStorage.removeItem("access_token_admin");
      return error.response;
    } else if (error.response.status === 404) {
      return error.response;
    } else {
      return error.response;
    }
  }
);

export const UserCertificate = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

UserCertificate.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token_admin");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

UserCertificate.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = "/admin-login";
      localStorage.removeItem("access_token_admin");
    }
    return error.response || Promise.reject(error);
  }
);
